export class Apps {
	static readonly CsGo: number = 730
	static readonly Dota2: number = 570
	static readonly Tf2: number = 440
	static readonly Rust: number = 252490
}
